import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import VideoSection from './components/VideoSection';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Shop from './components/Shop';
import Footer from './components/Footer';
import SocialLinks from './components/SocialLinks';
import ServicePage from './pages/ServicePage';
import PortfolioPage from './pages/PortfolioPage';
import TosPage from './pages/TosPage';
import CommissionPage from './pages/CommissionPage';
import ShopPage from './pages/ShopPage';
import ResourcesPage from './pages/ResourcesPage';
import DocsPage from './pages/DocsPage';

function HomePage() {
  return (
    <Box sx={{ background: '#0d0a12', minHeight: '100vh' }}>
      <Hero />
      <VideoSection />
      <About />
      <Services />
      <Portfolio />
      <Shop />
      <SocialLinks />
      <Footer />
    </Box>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/:id" element={<ServicePage />} />
        <Route path="/portfolio/:id" element={<PortfolioPage />} />
<Route path="/tos" element={<TosPage />} />
        <Route path="/services/:id/start/:tierIndex" element={<CommissionPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/docs" element={<DocsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
